export function cssVariableWithOverride(cssVariable, fallback) {
    return "var(".concat(cssVariable, ", ").concat(fallback, ")");
}
